"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientPictureLoader = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var picture_loader_1 = require("./picture-loader");
var ClientPictureLoader = (function (_super) {
    tslib_1.__extends(ClientPictureLoader, _super);
    function ClientPictureLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClientPictureLoader.prototype.loadInner = function (data) {
        var _this = this;
        if (data.file)
            this.loadPictureByFile(data, function () { return _this.finalizeLoading(data, data); });
        else if (data.imageUrl)
            this.loadPictureByUrl(data, function () { return _this.finalizeLoading(data, data); });
        else if (data.base64)
            this.loadPictureByBase64(data, function () { return _this.finalizeLoading(data, data); });
        return data;
    };
    ClientPictureLoader.prototype.addLoadListener = function (cacheInfo, callback) {
        this.sizeUpdater.addLoadListener(cacheInfo, callback);
    };
    ClientPictureLoader.prototype.applyRequest = function (_jsonObj) {
        throw new Error(errors_1.Errors.InternalException);
    };
    return ClientPictureLoader;
}(picture_loader_1.PictureLoader));
exports.ClientPictureLoader = ClientPictureLoader;
